// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--webphone-panel-width:700px;--webphone-panel-height:110px}.webphone-tooltip.el-tooltip__popper{z-index:3100!important}", ""]);
// Exports
module.exports = exports;
